<template>
  <div class="driver-scheduling">
    <div class="search-form-box">
      <el-row :gutter="30">
        <el-form inline>
          <el-col :span="6">
            <el-form-item label="服务商:">
              <el-select style="width: 100%" clearable v-model="searchForm.companyId" placeholder="请选择">
                <el-option
                  v-for="item in supplierData"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="司机姓名:">
              <el-input style="width: 100%" clearable v-model="searchForm.keyword" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="">
              <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
              <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div class="custom-tip">已选择 {{selectRows.length}} 人 <span class="fen-diao" @click="handleFenBatch">批量排班</span></div>
    </div>
    <div class="custom-table-box">
      <custom-table
        ref="customTable"
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="true"
        :is-reserve-selection="true"
        row-key="driverId"
        @pagination="handleSizeChange"
        @selectionChange="handleSelectionChange">
        <template v-slot:startCityName="{ row }">{{row.startCityName}} - {{row.endCityName}}</template>
        <template v-slot:companyId="{ row }">
          <span>
            出勤 {{ row.dutyDays }} 天 | 不出勤 {{ row.notDutyDays }} 天 | 待排班 {{ row.unSchedulingDays }} 天
          </span>
        </template>
        <template v-slot:operation="{ row }">
          <span class="operate-btn" @click.stop="handlePaiBan(row)">排班</span>
        </template>
      </custom-table>
    </div>
    <!--    添加或编辑-->

    <driverCalendar ref="driverCalendar"></driverCalendar>
    <driverCalendarDialog ref="driverCalendarDialog"></driverCalendarDialog>
  </div>
</template>
<script>

import CustomTable from "@/components/CustomTable.vue";
import {defineComponent} from "vue";
import driverCalendar from "@/views/FleetLeaderWorkbench/DriverWorkforceManagement/driverCalendar.vue";
import driverCalendarDialog from "../driverSchedulingDialog.vue";
import tableMixin from "@/mixin/tableMixin";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import OperateBox from "@/components/OperateBox.vue";
import {getPage} from "@/views/FleetLeaderWorkbench/DriverWorkforceManagement/api";
import {getSelectSupplier} from "@/views/SystemManagement/ServiceManagement/api";

export default defineComponent({
  mixins: [tableMixin],
  components: {
    CustomTabBox,
    OperateBox,
    CustomTable,
    driverCalendar,
    driverCalendarDialog,
  },
  data() {
    return {
      getTableMethod: getPage,
      selectRows: [],
      searchForm: {
        companyId: "",
        keyword: "",
      },
      supplierData: [],
      tableColumn: [
        {
          label: "服务商",
          prop: "companyName",
          show: true,
        },
        {
          label: "司机姓名",
          prop: "username",

          show: true,
        },
        {
          label: "司机联系方式",
          prop: "phone",
          show: true,
        },

        {
          label: "车牌号码",
          prop: "carNumber",
          show: true,
        },
        {
          label: "运输路线",
          prop: "startCityName",
          scopeStatus: true,
          show: true,
        },
        {
          label: "近7日排班状态",
          prop: "companyId",
          scopeStatus: true,
          width: "300px",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "120px",
          scopeStatus: true,
          show: true,
        },
      ],
    }
  },
  created() {
    this.getOver();
  },
  methods: {
    handleSelectionChange(val) {
      this.selectRows = [...val]
    },
    handleFenBatch() {
      if (this.selectRows.length === 0) {
        this.$message.warning("请选择需要排班的司机")
        return
      }
      this.$refs.driverCalendarDialog.init(this.selectRows);
    },
    handleChangeTab(val) {
      this.selectTab = val;
    },
    handleCheck() {
      this.getTableData();
      this.getOver();
    },
    getOver() {
      getSelectSupplier({belongCompanyId: '',keyword: ''}).then((res) => {
        if (res.code === 200) {
          this.supplierData = res.data;
        }
      });
    },
    disabledDate(time) {
      // 获取今天和明天的日期
      const today = dayjs().startOf("day");
      const tomorrow = today.add(1, "day");

      // 将时间转换为dayjs对象
      const current = dayjs(time);

      // 只能选择今天或明天
      return !(current.isSame(today, "day") || current.isSame(tomorrow, "day"));
    },
    handlePaiBan(row) {
      this.$refs.driverCalendar.init(row);
    },
    handleReset() {
      this.searchForm.companyId = "";
      this.searchForm.keyword = "";
      this.tableOptions.currentPage = 1;
      this.searchPage();
    },
    handleEdit(row) {
      this.$refs.addOrEdit.init(this.searchForm.terminalType, row);
    }
  },
})
</script>
<style scoped lang="scss">
.driver-scheduling{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .search-table-box {
    display: flex;
    margin: 0 -0.1rem;
    .list-box {
      width: 25%;
      height: 0.9rem;
      border-radius: 0.08rem;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0 0.1rem;
      .list-box-num {
        font-size: 0.24rem;
        color: #000000;
        padding-bottom: 0.1rem;
        font-weight: bold;
      }
      .list-box-label {
        font-size: 0.14rem;
        color: #434343;
      }
    }
  }
  .custom-table-box {
    padding-top: 0;
  }
  .custom-tip {
    font-size: 0.16rem;
    padding: 0.16rem 0.2rem;
    background: rgba(18, 105, 255, 0.05);
    box-sizing: border-box;
    margin: 0 0rem;
    border-radius: 0.03rem;
    border: 0.01rem dashed #1269ff;
  }
  .fen-diao{
    cursor: pointer;
    color: #1269ff;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
